export enum TeachingLanguage {
  English = 1,
  Arabic = 2,
  Both = 3,
}

export enum ClassMode {
  Offline = 1,
  Online = 2,
  Hybrid = 3,
}

export enum STATUS {
  PENDING = 1,
  APPROVED = 2,
  REJECTED = 3,
}

export enum APP_ROLE {
  TUTOR = 1,
  PARENT = 2,
}

export enum CONTENT_TYPE {
  FORUM = 1,
  SHORT_VIDEO = 2,
  TEASER_VIDEO = 3,
  POST = 4,
}

export enum SORT_TYPE {
  LATEST = 1,
  OLDEST = 2,
}

export enum FORUM_TYPE {
  SELF = 1,
  OTHERS = 2,
}

export enum LISTING {
  CATEGORY = 1,
  SUBJECT = 2,
  TUTOR_SUBJECT = 3,
  PROMOCODE = 4,
  CLASSES = 5,
}

export enum CLASS_TYPE {
  NORMAL = 1,
  RECURRENCE = 2,
}

export enum RECURRENCE_TYPE {
  DAILY = 1,
  WEEKLY = 2,
  MONTHLY = 3,
}

export enum BOOKING_STATUS {
  UPCOMING = 1,
  PAST = 2,
  ONGOING = 3,
}

export enum BULK_STATUS {
  ACCEPT = 1,
  REJECT = 2,
  DELETE = 3,
  UPDATE = 4,
}

export enum INQUIRY_REVERT {
  REVERT = 1,
  FORWARD = 2,
}

export enum CLASS_MODE {
  OFFLINE = 1,
  ONLINE = 2,
}
export enum TEACHING_LANGUAGE {
  ENGLISH = 1,
  ARABIC = 2,
  BOTH = 3,
}
export enum CLASS_SETTING {
  PUBLISH = 1,
  DRAFT = 2,
}
export enum CLASS_WAY {
  NORMAL = 1,
  RECURRENCE = 2,
}
export enum CLASS_TYPE_NEW {
  NORMAL = 1,
  MASTER = 2,
  WORKSHOP = 3,
  SEMINAR = 4,
}
export enum CLASS_PAYMENT {
  PER_HOUR = 1,
  SESSION = 2,
}

export enum CLASS_TYPE2 {
  NORMAL = 1,
  MASTER = 2,
  WORKSHOP = 3,
  SEMINAR = 4,
}

export enum INQUIRY_TYPE {
  TEACHING_STYLE = 1,
  AVAILABILITY = 2,
  RESOURCES = 3,
  SUBJECT = 4,
  OTHERS = 5,
}

export enum REPORT_CONTENT {
  NUDITY_SEXUAL = 1,
  VIOLENCE_HARMFUL_BEHAVIOR = 2,
  MISINFORMATION_FAKE_NEWS = 3,
  HARASSMENT_HATE_SPEECH = 4,
  SPAM_SCAMS = 5,
  COPYRIGHT_INFRINGEMENT = 6,
  CHILD_SAFETY_VIOLATIONS = 7,
}

export enum DASHBOARD_TYPE {
  OVERALL = 1,
  TUTOR = 2,
  CLASS = 3,
  CONTENT = 4,
}

export enum DocumentType {
  EDUCATION = 1,
  POLICE_CLEARANCE = 2,
  NATIONAL_ID = 3,
  HEADSHOT = 4,
  SELFIE = 5,
}

export const TEACHING_STYLE = {
  1: "Visual Learning",
  2: "Auditory Learning",
  3: "Reading and Writing",
  4: "Integrated Approach",
  5: "Other",
};

export const CURRICULUM = {
  1: "National Curriculum",
  2: "Cambridge Curriculum",
  3: "IB Curriculum",
  4: "American Curriculum",
};

export const GRADE_TYPE = {
  PRE_K: 1,
  KINDERGARTEN: 2,
  GRADE_1: 3,
  GRADE_2: 4,
  GRADE_3: 5,
  GRADE_4: 6,
  GRADE_5: 7,
  GRADE_6: 8,
  GRADE_7: 9,
  GRADE_8: 10,
  GRADE_9: 11,
  GRADE_10: 12,
  GRADE_11: 13,
  GRADE_12: 14,
  COLLEGE: 15,
  ADULT_LEARNING: 16,
  ALL_AGES: 17,
};

export const HIGHER_EDUCATION_TYPE = {
  DIPLOMA: 1,
  BACHELORS: 2,
  MASTERS: 3,
  PHD: 4,
  OTHERS: 5,
};

// Individual grade types
export const GRADE_TYPE_NAME: Record<number, string> = {
  1: "Pre-K (Ages 3-4)",
  2: "Kindergarten (Ages 5-6)",
  3: "Grade 1 (Ages 6-7)",
  4: "Grade 2 (Ages 7-8)",
  5: "Grade 3 (Ages 8-9)",
  6: "Grade 4 (Ages 9-10)",
  7: "Grade 5 (Ages 10-11)",
  8: "Grade 6 (Ages 11-12)",
  9: "Grade 7 (Ages 12-13)",
  10: "Grade 8 (Ages 13-14)",
  11: "Grade 9 (Ages 14-15)",
  12: "Grade 10 (Ages 15-16)",
  13: "Grade 11 (Ages 16-17)",
  14: "Grade 12 (Ages 17-18)",
  15: "College (Ages 18+)",
  16: "Adult Learning (Ages 25+)",
  17: "All Ages",
};

// Category options
export const gradeCategories = [
  {
    label: "Pre primary(Kg/Foundation)",
    value: "pre-primary",
    grades: [1, 2], // Pre-K and Kindergarten
  },
  {
    label: "Primary",
    value: "primary",
    grades: [3, 4, 5, 6, 7], // Grades 1-5
  },
  {
    label: "Middle school (O-level)",
    value: "middle-school",
    grades: [8, 9, 10], // Grades 6-8
  },
  {
    label: "High school (A-level)",
    value: "high-school",
    grades: [11, 12, 13, 14], // Grades 9-12
  },
  {
    label: "College",
    value: "college",
    grades: [15, 16], // College and Adult Learning
  },
  {
    label: "Other",
    value: "other",
    grades: [17], // All Ages
  },
];

export enum REPORT_CHAT {
  SCAM_FRAUD = 1,
  HARASSMENT = 2,
  OFF_PLATFORM_TRANSACTION = 3,
  INAPPROPRIATE_CONTENT = 4,
  SPAM = 5,
  OTHER = 6,
}
